import { Reducer } from "redux";
import { AuthActionType, AuthActionTypes } from "../actions";
import { jwtDecode } from "jwt-decode";
import { DEFAULT_ORDER, DEFAULT_ORDER_BY, DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../../constants/Constant";

export interface AuthState {
    isAuthenticated: boolean;
    token: string | null;
    error: string | null;
    admin: any;
    quoteAdminModels: any;
    optionState: any;
    modelState: any;
    quoteState: any;
}

const initialState: AuthState = {
    isAuthenticated: false,
    token: localStorage.getItem("admin_access_token") || null,
    error: null,
    admin: (() => {
        const token = localStorage.getItem("admin_access_token");
        if (!token) return null;
        try {
            return jwtDecode(token);
        } catch {
            return null;
        }
    })(),
    quoteAdminModels: [],
    optionState: {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
        order: DEFAULT_ORDER,
        orderBy: DEFAULT_ORDER_BY
    },
    modelState: {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
        order: DEFAULT_ORDER,
        orderBy: "Product Name"
    },
    quoteState: {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
        order: DEFAULT_ORDER,
        orderBy: DEFAULT_ORDER_BY
    }
};

export const adminAuthReducer: Reducer<AuthState, AuthActionTypes> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case AuthActionType.LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.token,
                error: null,
                admin: jwtDecode(action.payload.token),
            };
        case AuthActionType.LOGIN_FAILURE:
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                error: action.payload.error,
            };
        case AuthActionType.LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                error: null,
                admin: null,
            };

        // regarding quote store
        case AuthActionType.SET_QUOTE_ADMIN_MODELS:
            return {
                ...state,
                quoteAdminModels: action.payload.quoteModels,
            };

        case AuthActionType.SET_OPTION_STATE:
            return {
                ...state,
                optionState: { ...state.optionState, ...action.payload.optionState },
            };

        case AuthActionType.SET_MODEL_STATE:
            return {
                ...state,
                modelState: { ...state.modelState, ...action.payload.modelState },
            };

        case AuthActionType.SET_QUOTE_STATE:
            return {
                ...state,
                quoteState: { ...state.quoteState, ...action.payload.quoteState },
            };
        default:
            return state;
    }
};
